import * as React from 'react';

const StickyCourseContext = React.createContext({
  isEnabled: false,
  setEnabled: () => {}
});
export const useStickyCourseContext = () =>
  React.useContext(StickyCourseContext);
export const StickyCourseProvider = ({ children }) => {
  const [isEnabled, setEnabled] = React.useState(false);
  return (
    <StickyCourseContext.Provider value={{ isEnabled, setEnabled }}>
      {children}
    </StickyCourseContext.Provider>
  );
};
